import { render } from "./ConsumerSalesStatus.vue?vue&type=template&id=e72b7e72"
import script from "./ConsumerSalesStatus.vue?vue&type=script&lang=js"
export * from "./ConsumerSalesStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__